// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"4":"fe0e60b2","111":"d05d6dd6","159":"c13e2b11","450":"fa84ea86","780":"dbbd21d7"}[chunkId] + ".chunk.js";
};